import axios from "../../utils/request";

const state = {
  status: "",
  token: localStorage.getItem("token") || "",
  user: JSON.parse(localStorage.getItem("user")) || {},
};

const getters = {
  isLoggedIn: (state) => !!state.token,
  authStatus: (state) => state.status,
  token: (state) => state.token,
  userInfo: (state) => state.user,
};

const actions = {
  login({ commit }, user) {
    commit("auth_request");
    return new Promise((resolve, reject) => {
      axios({
        url: "auth/admin/login",
        data: user,
        method: "POST",
      })
        .then((resp) => {
          if (resp.status == 200 && resp.data.status == true) {
            const data = resp.data.data;
            const token = "Bearer " + data.token;
            const user = {
              username: data.username,
              email: data.email,
              image: data.profile_image,
              mobile: data.mobile,
              last_name: data.last_name,
              first_name: data.first_name,
            };
            // Remove Current Values From Local Storage
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            // Set New Values to Local Storage
            localStorage.setItem("token", token);
            localStorage.setItem("user", JSON.stringify(user));
            // Default header details
            axios.defaults.headers.common["Authorization"] = token;
            commit("auth_success", {
              token: token,
              user: user,
            });
            resolve(resp);
          }
          reject(resp);
        })
        .catch((err) => {
          commit("auth_error");
          localStorage.removeItem("token");
          reject(err);
        });
    });
  },
  logout() {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    delete axios.defaults.headers.common["Authorization"];
    return Promise.resolve();
  },
};

const mutations = {
  auth_request(state) {
    state.status = "loading";
  },
  auth_success(state, data) {
    state.user = data.user;
    state.status = "success";
    state.token = data.token;
  },
  auth_error(state) {
    state.status = "error";
  },
  logout(state) {
    state.status = "";
    state.token = "";
    state.user = {};
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
